export default __webpack_public_path__ + "static/media/will-power-logo-2.65a908e3.png";